import { NotAuthenticated } from '@feathersjs/errors/lib';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import useFeathers from '#/compositions/useFeathers';
import logger from '#/logger';

import { ONLINE_RECONNECT_STRATEGY } from './auth';

export const useWebsocketStore = defineStore('websocket', () => {
  const isConnected = ref(false);
  const isAuthenticated = ref(false);

  async function connect(): Promise<void> {
    logger.info('[Websocket] Connecting...');
    try {
      await useFeathers().reAuthenticate(
        true,
        import.meta.env.VITE_APP_MODE !== 'cloud' ? ONLINE_RECONNECT_STRATEGY : undefined,
      );
      setAuthenticated(true);
    } catch (error) {
      if (!(error instanceof NotAuthenticated)) {
        logger.error('[Websocket] Error at connecting...', error);
        throw error;
      }
    }
    logger.info('[Websocket] Connected');
    isConnected.value = true;
  }
  function disconnect(): void {
    logger.info('[Websocket] Disconnected');
    isConnected.value = false;
    setAuthenticated(false);
  }

  function setAuthenticated(newIsAuthenticated: boolean): void {
    logger.info('[Websocket] Authenticated ', newIsAuthenticated);
    isAuthenticated.value = newIsAuthenticated;
  }

  return {
    isConnected,
    isAuthenticated,
    setAuthenticated,
    connect,
    disconnect,
  };
});
